export async function executeOnDocumentReady(callback) {
	if (document.readyState === 'loading') {
		await new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
	callback();
}

export function getCookie(cname) {
	let name = cname + '=';
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(';');
	if (ca && ca.length > 0) {
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) === 0) {
				return c.substring(name.length, c.length);
			}
		}
	}
	return '';
}
export function setCookie(key, value, seconds) {
	const cookieExpiration = new Date();
	cookieExpiration.setTime(cookieExpiration.getTime() + (seconds || 31536000) * 1000); // 31536000 = year in seconds
	document.cookie = key + '=' + value + '; expires=' + cookieExpiration.toUTCString() + '; path=/';
}


// Helper function to remove diacritics and transliterate special characters
// nette Strings::toAscii rewritten by GPT
function toAscii(str) {
	// Remove control characters and keep valid UTF-8 characters
	str = str.replace(/[^\x09\x0A\x0D\x20-\x7E\xA0-\u02FF\u0370-\u10FFFF]/gu, '');

	// Basic transliterations for specific characters
	const directReplacements = {
		"\u201E": '"', "\u201C": '"', "\u201D": '"', "\u201A": "'", "\u2018": "'", "\u2019": "'",
		"\u00C4": 'Ae', "\u00D6": 'Oe', "\u00DC": 'Ue',
		"\u1E9E": 'Ss', "\u00E4": 'ae', "\u00F6": 'oe', "\u00FC": 'ue', "\u00DF": 'ss'
	};

	str = str.replace(/[\u201E\u201C\u201D\u201A\u2018\u2019\u00B0\u042F\u044F\u042E\u044E\u00C4\u00D6\u00DC\u1E9E\u00E4\u00F6\u00FC\u00DF]/g, char => directReplacements[char] || char);

	// Check for browser/JS-specific transliterations (Intl or other)
	if (typeof Intl !== 'undefined' && Intl.Collator) {
		// Transliteration using Intl if available
		str = str.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); // Decompose and remove diacritics
	}

	// Remove any remaining non-ASCII characters
	str = str.replace(/[^\x00-\x7F]/g, '');

	return str;
}

// Function to webalize the string by removing unwanted characters and replacing them with hyphens
// nette Strings::webalize rewritten by GPT
export function webalize(str, charlist = null, lower = true) {
	// Convert string to ASCII-friendly version
	str = toAscii(str);

	// Optionally convert to lowercase
	if (lower) {
		str = str.toLowerCase();
	}

	// Replace all characters except a-z, 0-9, and characters from charlist with hyphens
	const allowedChars = charlist ? charlist.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&') : '';
	str = str.replace(new RegExp(`[^a-z0-9${allowedChars}]+`, 'g'), '-');

	// Remove leading and trailing hyphens
	str = str.replace(/^-+|-+$/g, '');

	return str;
}
